<template>
  <base-module
    :definition="cranksetDefinitions"
    :installed="false"
    :error="motorStatus.highTemperature"
    :content-active="
      !motorStatus.overcurrent &&
      !motorStatus.stalled &&
      !motorStatus.highTemperature
    "
  >
    <template #title> {{ t('modules.pedalAnalyzer.index') }} </template>

    <template #left>
      <n-progress
        type="circle"
        :percentage="cadenceAsPercentage"
      >
        <span style="text-align: center">
          <h2 style="margin-bottom: 0">{{ cadence }}</h2>
          <h5 style="margin-bottom: 0">{{ cranksetCadence.unit }}</h5>
        </span>
      </n-progress>
    </template>

    <template #right>
      <n-form
        ref="formRef"
        label-placement="left"
      >
        <n-form-item label="L">
          <n-input-group>
            <n-input-number
              :value="smoothnessLeft"
              :show-button="false"
              readonly
            />
            <n-input-group-label>{{
              cranksetSmoothnessLeft.unit
            }}</n-input-group-label>
          </n-input-group>
        </n-form-item>

        <n-form-item label="R">
          <n-input-group>
            <n-input-number
              v-model:value="smoothnessRight"
              :show-button="false"
            />
            <n-input-group-label>{{
              cranksetSmoothnessRight.unit
            }}</n-input-group-label>
          </n-input-group>
        </n-form-item>
      </n-form>
    </template>
  </base-module>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseModule from './BaseModule.vue'
import {
  NProgress,
  NInputNumber,
  NInputGroup,
  NInputGroupLabel,
  NForm,
  NFormItem,
} from 'naive-ui'
import { useI18n } from 'vue-i18n'

import { useMqttStore } from '@/store/mqttStore'
import { useDeviceStore } from '@/store/deviceStore'
import { storeToRefs } from 'pinia'

const { t } = useI18n()
const mqttStore = useMqttStore()
const deviceStore = useDeviceStore()
const { getMessageOnTopic } = storeToRefs(mqttStore)
const { motorStatus } = storeToRefs(deviceStore)

import {
  cranksetDefinitions,
  cranksetCadence,
  cranksetSmoothnessLeft,
  cranksetSmoothnessRight,
} from '@/mqttDefinitions'

const cadence = computed(() => {
  return getMessageOnTopic.value(cranksetCadence)
})

import { valueAsPercentage, CADENCE_MAX } from '@/outputVariables'

const cadenceAsPercentage = computed(() => {
  return valueAsPercentage(cadence.value, CADENCE_MAX)
})

const smoothnessLeft = computed(() => {
  return getMessageOnTopic.value(cranksetSmoothnessLeft)
})

const smoothnessRight = computed(() => {
  return getMessageOnTopic.value(cranksetSmoothnessRight)
})
</script>
<style lang="scss"></style>
